const { produce: next } = require('immer')

/** UI column keys for Completion Report status sort */
const statusSortKey = {
  NOT_STARTED: 'notStarted',
  ASSIGNED: 'assigned',
  ABSENT: 'absent',
  NOT_OPEN: 'notOpen',
  IN_PROGRESS: 'inProgress',
  SUBMITTED: 'submitted',
  GRADED: 'graded',
}

/** Maps UI statusSortKey values → Redshift / API DB column aliases */
const statusMap = {
  [statusSortKey.NOT_STARTED]: 'not_started',
  [statusSortKey.ASSIGNED]: 'assigned',
  [statusSortKey.ABSENT]: 'absent',
  [statusSortKey.IN_PROGRESS]: 'in_progress',
  [statusSortKey.SUBMITTED]: 'submitted',
  [statusSortKey.GRADED]: 'graded',
  [statusSortKey.NOT_OPEN]: 'not_open',
}

const TABLE_SORT_KEYS = statusMap

const DEFAULT_TABLE_SORT_KEY = statusMap[statusSortKey.NOT_STARTED]
const DEFAULT_TABLE_SORT_ORDER = 'desc'
const DEFAULT_TEST_ORDER = 'desc'

const sortKeys = {
  COMPARE_BY: 'compareBy',
}
const tableColumnsData = [
  {
    dataIndex: sortKeys.COMPARE_BY,
    key: sortKeys.COMPARE_BY,
    fixed: 'left',
    width: 250,
  },
]

const tableColumns = [
  {
    title: 'Test Name',
    dataIndex: 'testName',
    key: 'testName',
    sorter: true,
    fixed: 'left',
    width: 250,
  },
  {},
  {
    title: '# Assigned',
    dataIndex: 'assigned',
    key: 'assigned',
    sorter: true,
    align: 'center',
  },
  {
    title: 'Not open',
    dataIndex: 'notOpen',
    key: 'notOpen',
    className: 'absent',
    align: 'center',
  },
  {
    title: 'Absent',
    dataIndex: 'absent',
    key: 'absent',
    className: 'absent',
    align: 'center',
  },
  {
    title: 'Not started',
    dataIndex: 'notStarted',
    key: 'notStarted',
    className: 'absent',
    align: 'center',
  },
  {
    title: 'In progress',
    dataIndex: 'inProgress',
    key: 'inProgress',
    align: 'center',
  },
  {
    title: 'Submitted',
    dataIndex: 'submitted',
    key: 'submitted',
    align: 'center',
  },
  {
    title: 'GRADED',
    dataIndex: 'graded',
    key: 'graded',
    align: 'center',
  },
]

const getTableColumnsBE = (compareBy) => {
  // Adding 2nd column based on compareBy
  const columnByCompareBy = next(tableColumnsData, (_columns) => {
    const compareByIdx = _columns.findIndex(
      (col) => col.key === sortKeys.COMPARE_BY
    )
    _columns[compareByIdx].title = compareBy.title
    _columns[compareByIdx].dataIndex = 'dimensionName'
  })

  tableColumns[1] = columnByCompareBy[0]

  return tableColumns
}

const isAnalyseByPercentage = (analyseBy) => analyseBy === 'percentage'

const getCellValue = (value, total, analyseBy) => {
  const isAnalyseByPercent = isAnalyseByPercentage(analyseBy)
  let totalValue = value || 0
  if (isAnalyseByPercent) {
    totalValue = Math.round((totalValue * 100) / total)
  }
  return `${totalValue || 0}${isAnalyseByPercent ? '%' : ''}`
}

const getTableData = (tableData) => {
  const overAllData = {
    testId: 'overall_tid',
    testName: 'Overall',
    testType: '',
    assigned: tableData?.[0]?.totalAssigned || 0,
    inProgress: tableData?.[0]?.totalInProgress || 0,
    submitted: tableData?.[0]?.totalSubmitted || 0,
    absent: tableData?.[0]?.totalAbsent || 0,
    notStarted: tableData?.[0]?.totalNotStarted || 0,
    notOpen: tableData?.[0]?.totalNotOpen || 0,
    graded: tableData?.[0]?.totalGraded || 0,
    dimensionName: '',
    dimensionId: '',
  }
  return [overAllData, ...tableData]
}

module.exports = {
  statusSortKey,
  statusMap,
  TABLE_SORT_KEYS,
  DEFAULT_TABLE_SORT_KEY,
  DEFAULT_TABLE_SORT_ORDER,
  DEFAULT_TEST_ORDER,
  getTableColumnsBE,
  getTableData,
  getCellValue,
  isAnalyseByPercentage,
}
